import { Injectable, signal } from '@angular/core';
import { ProductionCardSearchCommandPaginated, ProductionCardResultItem } from '../../models/production/production-card-search';
import { RollSearchCommand } from '../../models/production/roll-search';
import { Roll } from '../../models/production/roll';

/**
 * View mode type for the production inventory component
 */
export type ProductionViewMode = 'roll' | 'productionCard';

@Injectable({
  providedIn: 'root',
})
export class ProductionInventoryService {
  // Current view mode
  readonly viewMode = signal<ProductionViewMode>('roll');

  // Roll view results
  readonly rollResults = signal<Roll[]>([]);

  // Production Card view results
  readonly productionCardResults = signal<ProductionCardResultItem[]>([]);

  // Search filters for Roll view
  readonly rollSearchFilters = signal<RollSearchCommand>({});

  // Search filters for Production Card view
  readonly productionCardSearchFilters = signal<ProductionCardSearchCommandPaginated>({});

  // Pagination state (kept in UI service, not in proxies)
  readonly rollSearchPage = signal<number>(1);
  readonly rollSearchPageSize = signal<number>(50);
  readonly productionCardSearchPage = signal<number>(1);
  readonly productionCardSearchPageSize = signal<number>(25);

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  constructor() {}

  /**
   * Set the current view mode
   */
  setViewMode(mode: ProductionViewMode): void {
    this.viewMode.set(mode);
  }

  /**
   * Set roll search results
   */
  setRollResults(results: Roll[]): void {
    this.rollResults.set(results);
  }

  /**
   * Set production card search results
   */
  setProductionCardResults(results: ProductionCardResultItem[]): void {
    this.productionCardResults.set(results);
  }

  /**
   * Set roll search filters
   */
  setRollSearchFilters(filters: RollSearchCommand): void {
    this.rollSearchFilters.set(filters);
  }

  /**
   * Set production card search filters
   */
  setProductionCardSearchFilters(filters: ProductionCardSearchCommandPaginated): void {
    this.productionCardSearchFilters.set(filters);
  }

  /**
   * Clear all results
   */
  clearResults(): void {
    this.rollResults.set([]);
    this.productionCardResults.set([]);
  }

  /**
   * Clear filters based on current view mode
   */
  clearFilters(): void {
    if (this.viewMode() === 'roll') {
      this.rollSearchFilters.set({});
    } else {
      this.productionCardSearchFilters.set({});
    }
  }
}
